/* Curve Replica theme – vanilla JS, no dependencies */
(function () {
  'use strict';

  var settings = window.themeSettings || { routes: {}, moneyFormat: '${{amount}}', cartType: 'drawer' };

  /* ---------------------------------------------------------
     Helpers
     --------------------------------------------------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Math.round(Number(cents) || 0);
    format = format || settings.moneyFormat || '{{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return withDelimiters(cents, 2);
        case 'amount_no_decimals': return withDelimiters(cents, 0);
        case 'amount_with_comma_separator': return withDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(cents, 2, "'", '.');
        case 'amount_with_space_separator': return withDelimiters(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return withDelimiters(cents, 0, ' ');
        case 'amount_with_period_and_space_separator': return withDelimiters(cents, 2, ' ', '.');
        default: return withDelimiters(cents, 2);
      }
    });
  }
  window.formatMoney = formatMoney;

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function num(v) { return parseFloat(String(v == null ? '' : v).replace(',', '.')) || 0; }

  function lockScroll(lock) { document.body.classList.toggle('is-locked', lock); }

  /* ---------------------------------------------------------
     Overlay / drawers / modals
     --------------------------------------------------------- */
  var overlay = document.querySelector('[data-page-overlay]');
  var openLayer = null;

  function openLayerEl(el) {
    closeLayer();
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-visible');
    lockScroll(true);
    openLayer = el;
    var focusable = el.querySelector('input[type="search"], button, a');
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
  }
  function closeLayer() {
    if (!openLayer) return;
    openLayer.classList.remove('is-open');
    openLayer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-visible');
    lockScroll(false);
    openLayer = null;
  }
  if (overlay) overlay.addEventListener('click', closeLayer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLayer(); });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-menu-open]')) { e.preventDefault(); openLayerEl(document.querySelector('[data-menu-drawer]')); return; }
    if (t.closest('[data-search-open]')) { e.preventDefault(); openLayerEl(document.querySelector('[data-search-modal]')); return; }
    if (t.closest('[data-cart-open]') && settings.cartType === 'drawer' && document.querySelector('[data-cart-drawer]')) {
      e.preventDefault(); openLayerEl(document.querySelector('[data-cart-drawer]')); return;
    }
    if (t.closest('[data-drawer-close]') || t.closest('[data-search-close]')) { closeLayer(); return; }
    var searchModal = document.querySelector('[data-search-modal]');
    if (searchModal && openLayer === searchModal && !t.closest('.search-modal__panel')) closeLayer();
  });

  /* ---------------------------------------------------------
     Cart
     --------------------------------------------------------- */
  var Cart = {
    sectionId: 'cart-drawer',

    updateCounts: function (count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    },

    renderDrawer: function (sectionsHtml) {
      if (!sectionsHtml || !sectionsHtml[this.sectionId]) return;
      var current = document.querySelector('[data-cart-drawer]');
      var doc = new DOMParser().parseFromString(sectionsHtml[this.sectionId], 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer]');
      if (current && fresh) current.innerHTML = fresh.innerHTML;
      var countEl = doc.querySelector('[data-cart-count]');
      if (countEl) this.updateCounts(countEl.textContent.trim());
    },

    add: function (items) {
      var self = this;
      var body = { items: items };
      var useDrawer = settings.cartType === 'drawer' && document.querySelector('[data-cart-drawer]');
      if (useDrawer) { body.sections = self.sectionId; body.sections_url = window.location.pathname; }
      return fetch((settings.routes.cartAdd || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok || res.data.status) {
            throw new Error(res.data.description || res.data.message || 'Error');
          }
          if (useDrawer) {
            self.renderDrawer(res.data.sections);
            openLayerEl(document.querySelector('[data-cart-drawer]'));
          } else {
            window.location.href = settings.routes.cart || '/cart';
          }
          document.dispatchEvent(new CustomEvent('cart:updated'));
          return res.data;
        });
    },

    change: function (line, quantity) {
      var self = this;
      var drawer = document.querySelector('[data-cart-drawer]');
      if (drawer) drawer.classList.add('is-loading');
      return fetch((settings.routes.cartChange || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: self.sectionId, sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.sections) self.renderDrawer(data.sections);
          if (typeof data.item_count === 'number') self.updateCounts(data.item_count);
        })
        .finally(function () { if (drawer) drawer.classList.remove('is-loading'); });
    }
  };
  window.ThemeCart = Cart;

  // Cart upsells: add the chosen variant
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-upsell-add]');
    if (!add) return;
    e.preventDefault();
    var wrap = add.closest('.upsell');
    var select = wrap && wrap.querySelector('[data-upsell-variant]');
    var id = Number(select ? select.value : add.dataset.variantId);
    add.classList.add('is-loading');
    var onCartPage = document.body.classList.contains('template-cart');
    var done = function () { if (onCartPage) window.location.reload(); };
    Cart.add([{ id: id, quantity: 1 }]).then(done).catch(function () { add.classList.remove('is-loading'); });
  });

  // Cart page: quantities update automatically
  document.addEventListener('change', function (e) {
    var qty = e.target.closest('[data-cart-page-qty]');
    if (qty && qty.form) qty.form.submit();
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-drawer] [data-cart-qty]');
    if (!btn) return;
    e.preventDefault();
    Cart.change(Number(btn.dataset.line), Math.max(0, Number(btn.dataset.cartQty)));
  });

  /* ---------------------------------------------------------
     Announcement bar
     --------------------------------------------------------- */
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.messages = Array.from(this.querySelectorAll('.announcement-bar__message'));
      if (this.messages.length < 2) return;
      this.index = 0;
      var self = this;
      var prev = this.querySelector('[data-announcement-prev]');
      var next = this.querySelector('[data-announcement-next]');
      if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); self.restart(); });
      if (next) next.addEventListener('click', function () { self.go(self.index + 1); self.restart(); });
      this.delay = (Number(this.dataset.autoplay) || 5) * 1000;
      this.restart();
    }
    visible() {
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      return this.messages.filter(function (m) {
        return !(mobile && m.classList.contains('announcement-bar__message--desktop')) && !(!mobile && m.classList.contains('announcement-bar__message--mobile'));
      });
    }
    go(i) {
      var list = this.visible();
      if (!list.length) return;
      this.index = (i + list.length) % list.length;
      this.messages.forEach(function (m) { m.classList.remove('is-active'); });
      list[this.index].classList.add('is-active');
    }
    restart() {
      var self = this;
      clearInterval(this.timer);
      this.timer = setInterval(function () { self.go(self.index + 1); }, this.delay);
    }
  }
  customElements.define('announcement-bar', AnnouncementBar);

  class HeaderComponent extends HTMLElement {}
  customElements.define('header-component', HeaderComponent);

  /* ---------------------------------------------------------
     Predictive search
     --------------------------------------------------------- */
  (function initPredictiveSearch() {
    var input = document.querySelector('[data-predictive-input]');
    var results = document.querySelector('[data-predictive-results]');
    if (!input || !results) return;
    var trending = document.querySelectorAll('[data-search-trending]');
    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; trending.forEach(function (t) { t.hidden = false; }); return; }
      fetch((settings.routes.predictiveSearch || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          trending.forEach(function (t) { t.hidden = products.length > 0; });
          if (!products.length) { results.innerHTML = '<p>No encontramos resultados.</p>'; return; }
          results.innerHTML = '<ul class="predictive-list">' + products.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '&width=120" alt="" loading="lazy">' : '';
            return '<li><a href="' + p.url + '">' + img + '<span><strong>' + p.title + '</strong><br>' + formatMoney(Math.round(parseFloat(p.price) * 100)) + '</span></a></li>';
          }).join('') + '</ul>';
        })
        .catch(function () {});
    }, 250);
    input.addEventListener('input', run);
  })();

  /* ---------------------------------------------------------
     Media gallery
     --------------------------------------------------------- */
  class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gallery-track]');
      this.slides = Array.from(this.querySelectorAll('.gallery__slide'));
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb-index]'));
      this.thumbTrack = this.querySelector('[data-thumbs]');
      this.counter = this.querySelector('[data-gallery-current]');
      var self = this;
      this.thumbs.forEach(function (t) {
        t.addEventListener('click', function () { self.goTo(Number(t.dataset.thumbIndex)); });
      });
      var prev = this.querySelector('[data-thumbs-prev]');
      var next = this.querySelector('[data-thumbs-next]');
      if (prev) prev.addEventListener('click', function () { self.goTo(Math.max(0, self.current() - 1)); });
      if (next) next.addEventListener('click', function () { self.goTo(Math.min(self.slides.length - 1, self.current() + 1)); });
      if (this.track) this.track.addEventListener('scroll', debounce(function () { self.setActive(self.current()); }, 60), { passive: true });
    }
    current() {
      if (!this.track || !this.track.clientWidth) return 0;
      return Math.round(this.track.scrollLeft / this.track.clientWidth);
    }
    goTo(i) {
      if (!this.track || !this.slides[i]) return;
      this.track.scrollTo({ left: this.slides[i].offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      this.setActive(i);
    }
    goToMediaId(id) {
      var idx = this.slides.findIndex(function (s) { return s.dataset.mediaId === String(id); });
      if (idx > -1) this.goTo(idx);
    }
    setActive(i) {
      this.thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      if (this.counter) this.counter.textContent = i + 1;
      var thumb = this.thumbs[i];
      if (thumb && this.thumbTrack) {
        var left = thumb.offsetLeft - this.thumbTrack.offsetLeft;
        var right = left + thumb.offsetWidth;
        if (left < this.thumbTrack.scrollLeft || right > this.thumbTrack.scrollLeft + this.thumbTrack.clientWidth) {
          this.thumbTrack.scrollTo({ left: left - 10, behavior: 'smooth' });
        }
      }
    }
  }
  customElements.define('media-gallery', MediaGallery);

  /* ---------------------------------------------------------
     Product info (variants, bundle, buy buttons, sticky ATC)
     --------------------------------------------------------- */
  class ProductInfo extends HTMLElement {
    connectedCallback() {
      var jsonEl = this.querySelector('[data-product-json]');
      if (!jsonEl) return;
      this.product = JSON.parse(jsonEl.textContent);
      this.form = this.querySelector('[data-product-form]');
      this.gallery = this.querySelector('media-gallery');
      this.variant = this.findVariantById(this.form ? this.form.querySelector('[data-variant-id]').value : null) || this.product.variants[0];
      var self = this;

      this.querySelectorAll('[data-option-input]').forEach(function (input) {
        input.addEventListener('change', function () { self.onOptionChange(input); });
      });

      if (this.form) {
        this.form.addEventListener('submit', function (e) { e.preventDefault(); self.submit(); });
        this.atc = this.form.querySelector('[data-atc]');
        var qty = this.form.querySelector('[data-qty-input]');
        var minus = this.form.querySelector('[data-qty-minus]');
        var plus = this.form.querySelector('[data-qty-plus]');
        if (qty && minus && plus) {
          minus.addEventListener('click', function () { qty.value = Math.max(1, Number(qty.value) - 1); });
          plus.addEventListener('click', function () { qty.value = Number(qty.value) + 1; });
        }
      }

      this.initBundle();
      this.initSticky();
      this.initCoupon();
      this.updateAvailability();
    }

    findVariantById(id) {
      id = Number(id);
      return this.product.variants.find(function (v) { return v.id === id; });
    }
    findVariantByOptions(options) {
      return this.product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === options[i]; });
      });
    }
    selectedOptions() {
      return Array.from(this.querySelectorAll('[data-option-position]')).map(function (fs) {
        var checked = fs.querySelector('[data-option-input]:checked');
        return checked ? checked.value : null;
      });
    }

    onOptionChange(changedInput) {
      var options = this.selectedOptions();
      var variant = this.findVariantByOptions(options);
      if (!variant) {
        // keep the option the customer just picked, find the closest existing combination
        var changedIdx = 0;
        var fieldsets = Array.from(this.querySelectorAll('[data-option-position]'));
        fieldsets.forEach(function (fs, i) { if (changedInput && fs.contains(changedInput)) changedIdx = i; });
        variant = this.product.variants.find(function (v) { return v.options[changedIdx] === options[changedIdx] && v.available; }) ||
          this.product.variants.find(function (v) { return v.options[changedIdx] === options[changedIdx]; });
        if (variant) this.setOptionInputs(variant);
      }
      this.setVariant(variant);
    }

    setOptionInputs(variant) {
      var fieldsets = Array.from(this.querySelectorAll('[data-option-position]'));
      fieldsets.forEach(function (fs, i) {
        fs.querySelectorAll('[data-option-input]').forEach(function (input) {
          input.checked = input.value === variant.options[i];
        });
      });
    }

    setVariant(variant) {
      if (!variant) {
        if (this.atc) { this.atc.disabled = true; this.atc.querySelector('[data-atc-text]').textContent = 'No disponible'; }
        return;
      }
      this.variant = variant;
      var self = this;

      // hidden inputs (main form + installments)
      this.querySelectorAll('form input[name="id"]').forEach(function (input) {
        input.value = variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      // labels
      this.querySelectorAll('[data-option-position]').forEach(function (fs, i) {
        var label = fs.querySelector('[data-option-value]');
        if (label) label.textContent = variant.options[i];
      });

      // price
      this.querySelectorAll('[data-price-wrapper]').forEach(function (wrap) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        wrap.classList.toggle('price--on-sale', !!onSale);
        wrap.querySelector('[data-price]').textContent = formatMoney(variant.price);
        var cmp = wrap.querySelector('[data-compare-price]');
        if (cmp) { cmp.hidden = !onSale; cmp.textContent = onSale ? formatMoney(variant.compare_at_price) : ''; }
      });

      // atc
      if (this.atc) {
        this.atc.disabled = !variant.available;
        this.atc.querySelector('[data-atc-text]').textContent = variant.available ? 'Agregar al carrito' : 'Agotado';
      }

      // gallery
      if (variant.featured_media && this.gallery) this.gallery.goToMediaId(variant.featured_media.id);

      // url
      if (this.dataset.updateUrl === 'true' && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      // sticky
      if (this.stickyPrice) this.stickyPrice.textContent = formatMoney(variant.price);
      if (this.stickySelect) this.stickySelect.value = String(variant.id);

      this.updateAvailability();
      if (this.bundle) { this.resetBundleRows(); this.renderBundle(); }
      this.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant }, bubbles: true }));
    }

    updateAvailability() {
      var self = this;
      var selected = this.selectedOptions();
      var fieldsets = Array.from(this.querySelectorAll('[data-option-position]'));
      fieldsets.forEach(function (fs, i) {
        fs.querySelectorAll('[data-option-input]').forEach(function (input) {
          var candidate = selected.slice();
          candidate[i] = input.value;
          var match = self.product.variants.find(function (v) {
            return v.options.every(function (o, n) { return o === candidate[n]; });
          });
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    submit() {
      var self = this;
      if (!this.variant || !this.variant.available) return;
      var items;
      if (this.bundle) {
        items = this.getBundleItems();
      } else {
        var qtyInput = this.form.querySelector('[data-qty-input]');
        items = [{ id: this.variant.id, quantity: qtyInput ? Math.max(1, Number(qtyInput.value)) : 1 }];
      }
      var error = this.form.querySelector('[data-form-error]');
      if (error) error.hidden = true;
      if (this.atc) this.atc.classList.add('is-loading');
      Cart.add(items)
        .catch(function (err) {
          if (error) { error.textContent = err.message; error.hidden = false; }
        })
        .finally(function () { if (self.atc) self.atc.classList.remove('is-loading'); });
    }

    /* ---------- Bundle (quantity breaks) ---------- */
    initBundle() {
      this.bundle = this.querySelector('[data-bundle]');
      if (!this.bundle) return;
      var self = this;
      this.bundleTiers = Array.from(this.bundle.querySelectorAll('[data-bundle-tier]'));
      if (!this.bundleTiers.length) { this.bundle = null; return; }
      this.useCompare = this.bundle.dataset.useCompare === 'true';
      this.differentVariants = this.bundle.dataset.differentVariants === 'true' && this.product.variants.length > 1;
      this.addonSelect = this.bundle.querySelector('[data-look-addon-select]');
      if (this.addonSelect) this.addonSelect.addEventListener('change', function () { self.renderBundle(); });

      if (!this.bundle.querySelector('[data-bundle-tier].is-selected')) this.bundleTiers[0].classList.add('is-selected');

      this.bundleTiers.forEach(function (tier) {
        tier.addEventListener('click', function (e) {
          if (e.target.closest('select')) return;
          self.selectTier(tier);
        });
        tier.addEventListener('keydown', function (e) {
          if ((e.key === 'Enter' || e.key === ' ') && !e.target.closest('select')) { e.preventDefault(); self.selectTier(tier); }
        });
      });
      this.resetBundleRows();
      this.renderBundle();
    }

    selectTier(tier) {
      if (tier.classList.contains('is-selected')) return;
      this.bundleTiers.forEach(function (t) {
        t.classList.toggle('is-selected', t === tier);
        t.setAttribute('aria-checked', t === tier ? 'true' : 'false');
      });
      this.resetBundleRows();
      this.renderBundle();
    }

    currencyAmount(pairs) {
      var cur = String(settings.currency || '').toUpperCase(), out = 0;
      String(pairs || '').split(',').forEach(function (pair) {
        var kv = pair.split('=');
        if (kv.length === 2 && kv[0].trim().toUpperCase() === cur) out = Math.round(num(kv[1]) * 100);
      });
      return out;
    }

    round9() {
      var list = (this.bundle.dataset.round9 || '').split(/[\s,]+/);
      return list.indexOf(String(settings.currency || '').toUpperCase()) > -1;
    }

    selectedTier() { return this.bundle.querySelector('[data-bundle-tier].is-selected') || this.bundleTiers[0]; }

    resetBundleRows() {
      var tier = this.selectedTier();
      var qty = tier && !tier.hasAttribute('data-look') ? Number(tier.dataset.qty) || 1 : 1;
      this.bundleRows = [];
      for (var i = 0; i < qty; i++) this.bundleRows.push(this.variant);
    }

    variantPrice(v) { return Number(v.price) || 0; }
    variantCompare(v) {
      var p = this.variantPrice(v);
      var c = Number(v.compare_at_price) || 0;
      return this.useCompare && c > p ? c : p;
    }
    applyItemDiscount(price, type, value) {
      value = num(value);
      if (type === 'percent') return Math.round(price * (1 - value / 100));
      if (type === 'fixed') return Math.round(value * 100);
      return price;
    }

    tierPrices(tier) {
      var self = this;
      if (tier.hasAttribute('data-look')) {
        var addonVariant = this.currentAddonVariant();
        var mainPrice = this.variantPrice(this.variant);
        var mainNew = this.applyItemDiscount(mainPrice, tier.dataset.mainType, tier.dataset.mainValue);
        var mainCmp = this.variantCompare(this.variant);
        var addonNew = 0, addonCmp = 0;
        if (addonVariant) {
          addonNew = this.applyItemDiscount(this.variantPrice(addonVariant), tier.dataset.addonType, tier.dataset.addonValue);
          addonCmp = this.variantCompare(addonVariant);
        }
        return { total: mainNew + addonNew, compare: mainCmp + addonCmp, qty: 2, mainNew: mainNew, mainCmp: mainCmp, addonNew: addonNew, addonCmp: addonCmp };
      }
      var qty = Number(tier.dataset.qty) || 1;
      var rows = tier === this.selectedTier() && this.bundleRows.length === qty ? this.bundleRows : Array(qty).fill(this.variant);
      var sum = 0, cmp = 0;
      rows.forEach(function (v) { sum += self.variantPrice(v); cmp += self.variantCompare(v); });
      var type = tier.dataset.discountType;
      var value = num(tier.dataset.discountValue);
      var total = sum;
      if (type === 'percent') total = Math.round(sum * (1 - value / 100));
      else if (type === 'fixed_total' && value > 0) total = Math.round(value * 100);
      else if (type === 'amount_off') total = Math.max(0, sum - Math.round(value * 100) * qty);
      // Currencies with "ending in 9" prices (e.g. MXN): what Shopify really charges, rounded UP to the next whole price ending in 9
      var charge = num(tier.dataset.charge);
      if (this.round9() && charge > 0 && type !== 'none') {
        var real = sum - Math.round(sum * charge / 100);
        var units = Math.ceil(real / 100);
        total = (units + (19 - units % 10) % 10) * 100;
        // Optional fixed pack price for this currency (e.g. "MXN=1379"), only if it is not below the real charge
        var fixed = this.currencyAmount(tier.dataset.prices);
        if (fixed && fixed >= real) total = fixed;
      }
      return { total: total, compare: cmp, qty: qty };
    }

    currentAddonVariant() {
      // Add-on variant data comes from the <option>/<input> data attributes (no product JSON needed)
      var el = this.addonSelect;
      if (!el) return null;
      var opt = el.tagName === 'SELECT' ? el.options[el.selectedIndex] : el;
      if (!opt || !opt.value) return null;
      return { id: Number(opt.value), price: Number(opt.dataset.price) || 0, compare_at_price: Number(opt.dataset.compare) || 0 };
    }

    renderBundle() {
      var self = this;
      this.bundleTiers.forEach(function (tier) {
        try { self.renderTier(tier); } catch (err) { if (window.console) console.warn('Bundle tier', err); }
      });
      this.renderBundleRows();
    }

    renderTier(tier) {
      var self = this;
        var p = self.tierPrices(tier);
        var priceEl = tier.querySelector('[data-bundle-price]');
        var cmpEl = tier.querySelector('[data-bundle-compare]');
        var subEl = tier.querySelector('[data-bundle-subtitle]');
        if (priceEl) priceEl.textContent = formatMoney(p.total);
        if (cmpEl) cmpEl.textContent = p.compare > p.total ? formatMoney(p.compare) : '';
        if (subEl) {
          var saved = Math.max(0, p.compare - p.total);
          var pct = p.compare > 0 ? Math.round((saved / p.compare) * 100) : 0;
          // Tokens: [new_price] [saved_total] [saved_percentage] [original_price]
          subEl.textContent = (tier.dataset.subtitle || '')
            .replace(/\[\s*new_price\s*\]/g, formatMoney(self.round9() ? Math.floor(p.total / p.qty / 100) * 100 : Math.round(p.total / p.qty)))
            .replace(/\[\s*saved_total\s*\]/g, formatMoney(saved))
            .replace(/\[\s*saved_percentage\s*\]/g, pct + '%')
            .replace(/\[\s*original_price\s*\]/g, formatMoney(p.compare));
        }
        if (tier.hasAttribute('data-look')) {
          var set = function (sel, val) { var el = tier.querySelector(sel); if (el) el.textContent = val; };
          set('[data-look-main-price]', formatMoney(p.mainNew));
          set('[data-look-main-compare]', p.mainCmp > p.mainNew ? formatMoney(p.mainCmp) : '');
          set('[data-look-addon-price]', formatMoney(p.addonNew));
          set('[data-look-addon-compare]', p.addonCmp > p.addonNew ? formatMoney(p.addonCmp) : '');
          var img = tier.querySelector('[data-look-main-img]');
          var vImg = self.variant.featured_image && self.variant.featured_image.src;
          if (img && vImg) { img.removeAttribute('srcset'); img.src = self.resizeImage(vImg, 120); }
        }
    }

    resizeImage(src, width) {
      if (!src) return '';
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
    }

    renderBundleRows() {
      var self = this;
      this.bundleTiers.forEach(function (t) { var c = t.querySelector('[data-bundle-variants]'); if (c) c.innerHTML = ''; });
      var tier = this.selectedTier();
      if (!this.differentVariants || tier.hasAttribute('data-look')) return;
      var container = tier.querySelector('[data-bundle-variants]');
      if (!container) return;
      var options = this.product.options;
      var html = '<p class="bundle__variants-label">' + options.map(function (o) { return o.name || o; }).join(', ') + '</p>';
      this.bundleRows.forEach(function (variant, rowIndex) {
        var img = (variant.featured_image && variant.featured_image.src) || (self.product.featured_image || '');
        html += '<div class="bundle__variant-row" data-row="' + rowIndex + '">';
        if (self.bundleRows.length > 1) html += '<span class="bundle__variant-num">#' + (rowIndex + 1) + '</span>';
        html += img ? '<img class="bundle__variant-img" src="' + self.resizeImage(img, 80) + '" alt="">' : '';
        options.forEach(function (opt, optIndex) {
          var values = [];
          self.product.variants.forEach(function (v) { if (values.indexOf(v.options[optIndex]) === -1) values.push(v.options[optIndex]); });
          html += '<select class="bundle__select" data-row="' + rowIndex + '" data-opt="' + optIndex + '" aria-label="' + (opt.name || opt) + '">';
          values.forEach(function (val) {
            html += '<option value="' + val.replace(/"/g, '&quot;') + '"' + (variant.options[optIndex] === val ? ' selected' : '') + '>' + val + '</option>';
          });
          html += '</select>';
        });
        html += '</div>';
      });
      container.innerHTML = html;
      container.querySelectorAll('select').forEach(function (select) {
        select.addEventListener('change', function () {
          var row = Number(select.dataset.row);
          var opt = Number(select.dataset.opt);
          var wanted = self.bundleRows[row].options.slice();
          wanted[opt] = select.value;
          var match = self.findVariantByOptions(wanted) ||
            self.product.variants.find(function (v) { return v.options[opt] === select.value && v.available; }) ||
            self.product.variants.find(function (v) { return v.options[opt] === select.value; });
          if (match) self.bundleRows[row] = match;
          self.renderBundle();
        });
      });
    }

    getBundleItems() {
      var tier = this.selectedTier();
      var items = [];
      function push(id, qty) {
        var existing = items.find(function (i) { return i.id === id; });
        if (existing) existing.quantity += qty; else items.push({ id: id, quantity: qty });
      }
      if (tier.hasAttribute('data-look')) {
        push(this.variant.id, 1);
        var addon = this.currentAddonVariant();
        if (addon) push(addon.id, 1);
        return items;
      }
      var qty = Number(tier.dataset.qty) || 1;
      if (this.differentVariants && this.bundleRows.length === qty) {
        this.bundleRows.forEach(function (v) { push(v.id, 1); });
      } else {
        push(this.variant.id, qty);
      }
      return items;
    }

    /* ---------- Sticky add to cart ---------- */
    initSticky() {
      var sticky = this.querySelector('[data-sticky-atc]');
      if (!sticky || !this.atc) return;
      var self = this;
      this.stickyPrice = sticky.querySelector('[data-sticky-price]');
      this.stickySelect = sticky.querySelector('[data-sticky-select]');
      var btn = sticky.querySelector('[data-sticky-atc-btn]');
      if (btn) btn.addEventListener('click', function () { self.submit(); });
      if (this.stickySelect) {
        this.stickySelect.addEventListener('change', function () {
          var v = self.findVariantById(self.stickySelect.value);
          if (v) { self.setOptionInputs(v); self.setVariant(v); }
        });
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', past);
            sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
          });
        }).observe(this.atc);
      }
    }

    initCoupon() {
      this.querySelectorAll('[data-copy-code]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var code = btn.dataset.copyCode;
          var done = function () {
            var msg = btn.parentElement.querySelector('[data-copied]');
            if (msg) { msg.classList.add('is-visible'); setTimeout(function () { msg.classList.remove('is-visible'); }, 1500); }
          };
          if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
        });
      });
    }
  }
  customElements.define('product-info', ProductInfo);

  /* ---------------------------------------------------------
     Size finder
     --------------------------------------------------------- */
  var LBS_PER_KG = 2.20462;
  var CM_PER_IN = 2.54;

  function parseRange(str) {
    var parts = String(str).split(/[-–]/).map(function (s) { return parseFloat(s.replace(',', '.')); });
    var min = parts[0];
    var max = isNaN(parts[1]) ? parts[0] : parts[1];
    return [min, max];
  }

  // rows: [{size, len: {bust:[min,max], waist, hip}, wt:[min,max]}] in base units
  // values: {weight, bust, waist, hip} in base units (null if empty), fit: 'comfort' | 'shaping'
  function recommendSize(rows, values, fit) {
    function position(key, v) {
      if (v == null || isNaN(v)) return null;
      var ranges = rows.map(function (r) { return key === 'weight' ? r.wt : r[key]; });
      var matches = [];
      ranges.forEach(function (rg, i) { if (rg && v >= rg[0] && v <= rg[1]) matches.push(i); });
      if (matches.length === 1) return matches[0];
      if (matches.length > 1) return (matches[0] + matches[matches.length - 1]) / 2;
      if (v < ranges[0][0]) return 0;
      if (v > ranges[ranges.length - 1][1]) return ranges.length - 1;
      for (var i = 0; i < ranges.length - 1; i++) {
        if (v > ranges[i][1] && v < ranges[i + 1][0]) return i + 0.5;
      }
      return null;
    }
    var positions = [];
    var w = position('weight', values.weight);
    if (w === null) return null;
    positions.push(w, w);
    ['bust', 'waist', 'hip'].forEach(function (k) {
      var p = position(k, values[k]);
      if (p !== null) positions.push(p);
    });
    var avg = positions.reduce(function (a, b) { return a + b; }, 0) / positions.length;
    var frac = avg - Math.floor(avg);
    var between = frac >= 0.25 && frac <= 0.75;
    var idx;
    if (between) idx = fit === 'shaping' ? Math.floor(avg) : Math.ceil(avg);
    else idx = Math.round(avg);
    idx = Math.max(0, Math.min(rows.length - 1, idx));
    return { index: idx, between: between };
  }
  window.__recommendSize = recommendSize;

  function initSizeFinders() {
    document.querySelectorAll('[data-size-finder]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var dialog = root.querySelector('[data-size-finder-dialog]');
      var openBtn = root.querySelector('[data-size-finder-open]');
      var closeBtn = root.querySelector('[data-size-finder-close]');
      var form = root.querySelector('[data-size-finder-form]');
      var result = root.querySelector('[data-sf-result]');
      var error = root.querySelector('[data-sf-error]');
      var baseUnits = root.dataset.units === 'imperial' ? 'imperial' : 'metric';
      var displayUnits = baseUnits;
      var lastIndex = null;

      var rowsEls = Array.from(root.querySelectorAll('[data-sf-row]'));
      var rows = rowsEls.map(function (tr) {
        var cells = tr.querySelectorAll('[data-base]');
        return {
          size: tr.dataset.size,
          bust: parseRange(cells[0].dataset.base),
          waist: parseRange(cells[1].dataset.base),
          hip: parseRange(cells[2].dataset.base),
          wt: parseRange(cells[3].dataset.base)
        };
      });

      function convert(value, kind, from, to) {
        if (from === to || value == null || isNaN(value)) return value;
        if (kind === 'len') return from === 'metric' ? value / CM_PER_IN : value * CM_PER_IN;
        return from === 'metric' ? value * LBS_PER_KG : value / LBS_PER_KG;
      }

      function renderUnits() {
        root.querySelectorAll('[data-unit-len]').forEach(function (el) { el.textContent = displayUnits === 'metric' ? 'cm' : 'in'; });
        root.querySelectorAll('[data-unit-wt]').forEach(function (el) { el.textContent = displayUnits === 'metric' ? 'kg' : 'lbs'; });
        root.querySelectorAll('[data-sf-row] [data-base]').forEach(function (td) {
          var rg = parseRange(td.dataset.base);
          var kind = td.dataset.kind;
          var a = Math.round(convert(rg[0], kind, baseUnits, displayUnits));
          var b = Math.round(convert(rg[1], kind, baseUnits, displayUnits));
          td.textContent = a === b ? String(a) : a + '–' + b;
        });
        root.querySelectorAll('[data-unit]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.unit === displayUnits); });
      }

      root.querySelectorAll('[data-unit]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var next = btn.dataset.unit;
          if (next === displayUnits) return;
          ['weight', 'bust', 'waist', 'hip'].forEach(function (name) {
            var input = form.elements[name];
            if (input && input.value) {
              var v = convert(parseFloat(input.value.replace(',', '.')), name === 'weight' ? 'wt' : 'len', displayUnits, next);
              input.value = Math.round(v * 10) / 10;
            }
          });
          displayUnits = next;
          renderUnits();
        });
      });

      if (openBtn && dialog) openBtn.addEventListener('click', function () {
        if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
      });
      if (closeBtn && dialog) closeBtn.addEventListener('click', function () { dialog.close ? dialog.close() : dialog.removeAttribute('open'); });
      if (dialog) dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var read = function (name, kind) {
          var input = form.elements[name];
          if (!input || !input.value) return null;
          return convert(parseFloat(input.value.replace(',', '.')), kind, displayUnits, baseUnits);
        };
        var values = { weight: read('weight', 'wt'), bust: read('bust', 'len'), waist: read('waist', 'len'), hip: read('hip', 'len') };
        if (!values.weight || isNaN(values.weight)) { error.hidden = false; result.hidden = true; return; }
        error.hidden = true;
        var fitInput = form.querySelector('input[name="fit"]:checked');
        var rec = recommendSize(rows, values, fitInput ? fitInput.value : 'comfort');
        if (!rec) return;
        lastIndex = rec.index;
        var size = rows[rec.index].size;
        root.querySelector('[data-sf-size]').textContent = size;
        root.querySelector('[data-sf-note]').textContent = rec.between
          ? (fitInput && fitInput.value === 'shaping'
            ? 'Estás entre dos tallas: si quieres que moldee más, te recomendamos la ' + size + '.'
            : 'Estás entre dos tallas: para que te quede más cómodo, te recomendamos la ' + size + '.')
          : 'Con tus datos, la talla que mejor te queda es la ' + size + '.';
        result.hidden = false;
        rowsEls.forEach(function (tr, i) { tr.classList.toggle('is-recommended', i === rec.index); });
      });

      var selectBtn = root.querySelector('[data-sf-select]');
      if (selectBtn) selectBtn.addEventListener('click', function () {
        if (lastIndex === null) return;
        var size = rows[lastIndex].size.toUpperCase();
        var optionName = (root.dataset.sizeOption || '').toLowerCase();
        var info = root.closest('product-info');
        if (info) {
          info.querySelectorAll('[data-option-position]').forEach(function (fs) {
            var legend = fs.querySelector('legend strong');
            var name = legend ? legend.textContent.replace(':', '').trim().toLowerCase() : '';
            if (optionName && name !== optionName) return;
            var inputs = Array.from(fs.querySelectorAll('[data-option-input]'));
            var match = inputs.find(function (input) {
              var first = input.value.trim().split(/[\s(]/)[0].toUpperCase();
              return first === size || (first === '2XL' && size === '2X') || (first === '2X' && size === '2XL') || (first === '3XL' && size === '3X') || (first === '3X' && size === '3XL');
            });
            if (match) { match.checked = true; match.dispatchEvent(new Event('change', { bubbles: true })); }
          });
        }
        if (dialog && dialog.close) dialog.close();
      });

      renderUnits();
    });
  }
  initSizeFinders();

  /* ---------------------------------------------------------
     Before / after slider
     --------------------------------------------------------- */
  class BeforeAfterSlider extends HTMLElement {
    connectedCallback() {
      var range = this.querySelector('[data-compare-range]');
      var self = this;
      if (range) range.addEventListener('input', function () { self.style.setProperty('--pos', range.value + '%'); });
    }
  }
  customElements.define('before-after-slider', BeforeAfterSlider);

  /* ---------------------------------------------------------
     Video player
     --------------------------------------------------------- */
  class VideoPlayer extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      var self = this;
      var video = this.video;
      var playBtn = this.querySelector('[data-video-play]');
      var soundBtn = this.querySelector('[data-video-sound]');
      var toggle = this.querySelector('[data-video-toggle]');
      this.autoplay = video.autoplay;
      video.muted = video.muted || this.autoplay;

      if (playBtn) playBtn.addEventListener('click', function () {
        if (video.paused) video.play(); else video.pause();
      });
      if (soundBtn) soundBtn.addEventListener('click', function () {
        video.muted = !video.muted;
        soundBtn.classList.toggle('is-unmuted', !video.muted);
      });
      var togglePlay = function () {
        if (video.paused) {
          document.querySelectorAll('video-player.is-playing').forEach(function (p) { if (p !== self && p.video) p.video.pause(); });
          video.play();
        } else video.pause();
      };
      if (toggle) toggle.addEventListener('click', togglePlay);
      if (!playBtn) video.addEventListener('click', togglePlay);

      video.addEventListener('play', function () { self.classList.add('is-playing'); if (playBtn) playBtn.classList.remove('is-paused'); });
      video.addEventListener('pause', function () { self.classList.remove('is-playing'); if (playBtn) playBtn.classList.add('is-paused'); });

      if (this.autoplay && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { if (!self.userPaused) video.play().catch(function () {}); }
            else video.pause();
          });
        }, { threshold: 0.2 }).observe(this);
        if (playBtn) playBtn.addEventListener('click', function () { self.userPaused = video.paused; });
      }
    }
  }
  customElements.define('video-player', VideoPlayer);

  /* ---------------------------------------------------------
     Generic slider (scroll-snap)
     --------------------------------------------------------- */
  class SliderComponent extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-slider-track]');
      if (!this.track) return;
      this.slides = Array.from(this.track.children);
      this.prev = this.querySelector('[data-slider-prev]');
      this.next = this.querySelector('[data-slider-next]');
      this.dotsWrap = this.querySelector('[data-slider-dots]');
      var self = this;
      if (this.prev) this.prev.addEventListener('click', function () { self.move(-1); });
      if (this.next) this.next.addEventListener('click', function () { self.move(1); });
      this.track.addEventListener('scroll', debounce(function () { self.update(); }, 50), { passive: true });
      window.addEventListener('resize', debounce(function () { self.buildDots(); self.update(); }, 150));
      this.buildDots();
      this.update();
    }
    step() {
      if (this.slides.length < 2) return this.track.clientWidth;
      return this.slides[1].offsetLeft - this.slides[0].offsetLeft;
    }
    perView() { return Math.max(1, Math.round(this.track.clientWidth / this.step())); }
    move(dir) { this.track.scrollBy({ left: dir * this.step(), behavior: 'smooth' }); }
    buildDots() {
      if (!this.dotsWrap) return;
      var self = this;
      var pages = Math.max(1, this.slides.length - this.perView() + 1);
      this.dotsWrap.innerHTML = '';
      if (pages < 2) return;
      for (var i = 0; i < pages; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'slider__dot';
        b.setAttribute('aria-label', 'Diapositiva ' + (i + 1));
        (function (idx) { b.addEventListener('click', function () { self.track.scrollTo({ left: idx * self.step(), behavior: 'smooth' }); }); })(i);
        this.dotsWrap.appendChild(b);
      }
    }
    update() {
      var max = this.track.scrollWidth - this.track.clientWidth - 2;
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
      if (this.next) this.next.disabled = this.track.scrollLeft >= max;
      if (this.dotsWrap) {
        var idx = Math.round(this.track.scrollLeft / this.step());
        Array.from(this.dotsWrap.children).forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }
    }
  }
  customElements.define('slider-component', SliderComponent);

  /* ---------------------------------------------------------
     Slideshow
     --------------------------------------------------------- */
  class SlideshowComponent extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.slideshow__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-slide-to]'));
      if (this.slides.length < 2) return;
      this.index = 0;
      var self = this;
      this.dots.forEach(function (d) { d.addEventListener('click', function () { self.go(Number(d.dataset.slideTo)); self.restart(); }); });
      var start = null;
      this.addEventListener('touchstart', function (e) { start = e.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', function (e) {
        if (start === null) return;
        var dx = e.changedTouches[0].clientX - start;
        if (Math.abs(dx) > 40) { self.go(self.index + (dx < 0 ? 1 : -1)); self.restart(); }
        start = null;
      });
      this.restart();
    }
    go(i) {
      this.index = (i + this.slides.length) % this.slides.length;
      var idx = this.index;
      this.slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); });
      this.dots.forEach(function (d, n) { d.classList.toggle('is-active', n === idx); });
    }
    restart() {
      var self = this;
      clearInterval(this.timer);
      if (this.dataset.autoplay !== 'true') return;
      this.timer = setInterval(function () { self.go(self.index + 1); }, (Number(this.dataset.speed) || 5) * 1000);
    }
  }
  customElements.define('slideshow-component', SlideshowComponent);

  /* ---------------------------------------------------------
     Coverflow video slider
     --------------------------------------------------------- */
  class CoverflowSlider extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('[data-coverflow-card]'));
      if (!this.cards.length) return;
      this.index = Math.floor(this.cards.length / 2);
      var self = this;
      var prev = this.querySelector('[data-coverflow-prev]');
      var next = this.querySelector('[data-coverflow-next]');
      if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); });
      if (next) next.addEventListener('click', function () { self.go(self.index + 1); });
      this.cards.forEach(function (card, i) {
        card.addEventListener('click', function (e) {
          if (e.target.closest('a')) return;
          if (i !== self.index) { e.preventDefault(); self.go(i); return; }
          if (e.target.closest('[data-coverflow-play]')) self.toggleVideo(card);
        });
      });
      var start = null;
      this.addEventListener('touchstart', function (e) { start = e.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', function (e) {
        if (start === null) return;
        var dx = e.changedTouches[0].clientX - start;
        if (Math.abs(dx) > 40) self.go(self.index + (dx < 0 ? 1 : -1));
        start = null;
      });
      window.addEventListener('resize', debounce(function () { self.layout(); }, 100));
      this.layout();
    }
    toggleVideo(card) {
      var v = card.querySelector('video');
      if (!v) return;
      if (v.paused) { v.muted = false; v.play(); } else v.pause();
    }
    go(i) {
      var old = this.cards[this.index] && this.cards[this.index].querySelector('video');
      if (old) old.pause();
      this.index = Math.max(0, Math.min(this.cards.length - 1, i));
      this.layout();
    }
    layout() {
      var mobile = window.innerWidth < 1024;
      var offsets = mobile ? [0, 130, 215, 270] : [0, 245, 400, 510];
      var scales = [1, 0.8, 0.66, 0.55];
      var self = this;
      this.cards.forEach(function (card, i) {
        var d = i - self.index;
        var a = Math.min(Math.abs(d), 3);
        var x = (d < 0 ? -1 : 1) * offsets[a];
        card.style.transform = 'translate(' + x + 'px, -50%) scale(' + scales[a] + ')';
        card.style.zIndex = String(10 - a);
        card.style.opacity = Math.abs(d) > 3 ? '0' : '1';
        card.style.pointerEvents = Math.abs(d) > 3 ? 'none' : 'auto';
        card.style.filter = a === 0 ? 'none' : 'brightness(.92)';
      });
    }
  }
  customElements.define('coverflow-slider', CoverflowSlider);

  /* ---------------------------------------------------------
     Product recommendations
     --------------------------------------------------------- */
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      var self = this;
      if (this.querySelector('.product-grid')) return;
      var load = function () {
        fetch(self.dataset.url)
          .then(function (r) { return r.text(); })
          .then(function (text) {
            var html = new DOMParser().parseFromString(text, 'text/html');
            var fresh = html.querySelector('product-recommendations');
            if (fresh && fresh.innerHTML.trim().length) self.innerHTML = fresh.innerHTML;
          })
          .catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { io.disconnect(); load(); }
        }, { rootMargin: '0px 0px 400px 0px' });
        io.observe(this);
      } else load();
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  /* ---------------------------------------------------------
     Reviews widget
     --------------------------------------------------------- */
  class ReviewsWidget extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-reviews-list]');
      if (!this.list) return;
      this.items = Array.from(this.list.children);
      this.filter = 0;
      this.moreBtn = this.querySelector('[data-reviews-more]');
      this.perPage = this.moreBtn ? Number(this.moreBtn.dataset.perPage) : this.items.length;
      this.shown = this.perPage;
      var self = this;
      var panel = this.querySelector('[data-reviews-filter-panel]');
      var filtersBtn = this.querySelector('[data-reviews-filters]');
      if (filtersBtn && panel) filtersBtn.addEventListener('click', function () { panel.hidden = !panel.hidden; });
      this.querySelectorAll('[data-filter-rating]').forEach(function (b) {
        b.addEventListener('click', function () {
          var r = Number(b.dataset.filterRating);
          self.filter = self.filter === r ? 0 : r;
          self.querySelectorAll('.reviews__chip').forEach(function (c) { c.classList.toggle('is-active', Number(c.dataset.filterRating) === self.filter); });
          self.shown = self.perPage;
          self.render();
        });
      });
      var sort = this.querySelector('[data-reviews-sort]');
      if (sort) sort.addEventListener('change', function () { self.sort(sort.value); });
      if (this.moreBtn) this.moreBtn.addEventListener('click', function () { self.shown += self.perPage; self.render(); });
      this.querySelectorAll('[data-review-vote]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.classList.contains('is-voted')) return;
          b.classList.add('is-voted');
          var n = b.querySelector('span');
          if (n) n.textContent = Number(n.textContent) + 1;
        });
      });
      this.render();
    }
    sort(mode) {
      var items = this.items.slice();
      items.sort(function (a, b) {
        if (mode === 'photos') return Number(b.dataset.hasPhoto) - Number(a.dataset.hasPhoto) || Number(a.dataset.index) - Number(b.dataset.index);
        if (mode === 'highest') return Number(b.dataset.rating) - Number(a.dataset.rating);
        if (mode === 'lowest') return Number(a.dataset.rating) - Number(b.dataset.rating);
        return Number(a.dataset.index) - Number(b.dataset.index);
      });
      var list = this.list;
      items.forEach(function (i) { list.appendChild(i); });
      this.items = items;
      this.render();
    }
    render() {
      var self = this;
      var visible = 0, matching = 0;
      this.items.forEach(function (item) {
        var ok = !self.filter || Number(item.dataset.rating) === self.filter;
        item.classList.toggle('is-filtered', !ok);
        if (ok) {
          matching++;
          var show = visible < self.shown;
          item.classList.toggle('is-hidden-page', !show);
          if (show) visible++;
        }
      });
      var count = this.querySelector('[data-reviews-visible-count]');
      if (count) count.textContent = matching;
      if (this.moreBtn) this.moreBtn.parentElement.hidden = visible >= matching;
    }
  }
  customElements.define('reviews-widget', ReviewsWidget);

  /* ---------------------------------------------------------
     Product card swatches
     --------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.card__swatch');
    if (!sw) return;
    e.preventDefault();
    var card = sw.closest('[data-product-card]');
    if (!card) return;
    card.querySelectorAll('.card__swatch').forEach(function (s) { s.classList.toggle('is-active', s === sw); });
    var img = card.querySelector('[data-card-image]');
    if (img && sw.dataset.swatchImage) { img.removeAttribute('srcset'); img.src = sw.dataset.swatchImage; }
    var name = card.querySelector('[data-card-variant-name]');
    if (name) name.textContent = sw.dataset.swatchName;
  });

  /* Footer menus collapsed on mobile */
  if (window.matchMedia('(max-width: 1023px)').matches) {
    document.querySelectorAll('.footer__details[open]').forEach(function (d) { d.removeAttribute('open'); });
  }

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function () { initSizeFinders(); });
})();
